import React from 'react';
import PropTypes from 'prop-types';
import { faMapMarkerSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, Tooltip, Empty } from "antd";
import { CustomProgressBar } from "../../../common/components/dashboard";

class NoLocationProgressView extends React.Component {
  formatpercentage = (value, decimalplaces) => {
    if (value % 1 > 0)
    {
      return value.toFixed(decimalplaces);
    }

    return value.toFixed(0);  
  }

  render() {
    return (
      <>
        <div className="p5-form-container">
          <Row className="text-center" justify="space-around" align="middle">
            <Col span={24}>
              <div>
                <h1 className="p5-dash-h1-header text-center">
                  <span>
                    <FontAwesomeIcon
                      style={{color: '#B90505', marginRight: "5px"}}
                      icon={faMapMarkerSlash}
                    />
                  </span>
                  <span>
                    {this.props.title}
                  </span>
                </h1>
              </div>
            </Col>
          </Row> 
          <br /> 
          {
            this.props.noLocationReported.map((location) => (
              <Row key={`overdue-${location.RegistrationType}`} justify="space-around" align="middle">
                <Col span={8}><span>{location.RegistrationType}</span></Col>
                <Col span={16}>
                  <span style={{"float": "right"}}>
                    Total: {location.NoLocationCount} / {location.TotalRegistration}
                  </span>
                </Col>
                <Col span={22}> 
                  <div style={{marginBottom: "-25px auto"}}>
                    <Tooltip placement="left" title={location.RegistrationType}>
                      <span>
                        <CustomProgressBar 
                          height={100} 
                          width={300} 
                          percent={location.NoLocationCount / location.TotalRegistration} 
                          barWidthRatio={0.3} 
                          color={location.RegistrationType === 'TecSAFE App' ? ['#EF4E4E', '#E8EDF3'] : ['#243B53', '#E8EDF3']} 
                        />                            
                      </span>   
                    </Tooltip>   
                  </div>                    
                </Col>
                <Col span={2}>
                  <span style={{margin: "-25px 10px"}}>{this.formatpercentage((location.NoLocationCount * 100 / location.TotalRegistration), 2)}%</span>                        
                </Col>
              </Row>  
            ))
        }     
          {
            this.props.noLocationReported.length === 0 && (
              <>
                <Empty />
              </>
              )
          }   
          <br />
          <Row className="text-center" justify="space-around" align="middle">
            <Col span={24}>
              <div>
                <span><strong>Data in this section does not change by date filter</strong></span>
              </div>
            </Col>
          </Row>        
        </div>        
      </>
    );
  }
}

NoLocationProgressView.propTypes = {
//   loading: PropTypes.bool,
  title: PropTypes.string,
  noLocationReported: PropTypes.arrayOf(PropTypes.shape({})),
};

NoLocationProgressView.defaultProps = {
//   loading: false,
  title: "",
  noLocationReported: [],
};

export { NoLocationProgressView as default };
